module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"about":"Über…"},"en":{"about":"About…"}}')
  delete Component.options._Ctor
}
